import { useQuery } from "@tanstack/react-query";
import { AppWindow } from "lucide-react";
import { useTranslation } from "react-i18next";
import { listMicroAppsOptions } from "@/api";
import { Page } from "@/components/Page";
import { spaceAppPath } from "@/features/spaces/detail/spaceApp";
import { SpaceItemsList } from "./SpaceItemsList";
import { useSettingsSpace } from "./useSpaceSettings";

/** Micro-apps in the space: keep them private or share them; pin one to launch it from the space page. */
export function AppsSection() {
  const { t } = useTranslation("spaces", { keyPrefix: "settings.apps" });
  const space = useSettingsSpace();
  const apps = useQuery({
    ...listMicroAppsOptions({ query: { page_size: 100 } }),
    select: (r) => r.data.map((a) => ({ uuid: a.uuid, name: a.name, description: a.description })),
  });
  return (
    <Page title={t("title")}>
      <SpaceItemsList
        spaceUuid={space.uuid}
        type="micro_app"
        title={t("title")}
        addLabel={t("add")}
        addTitle={t("addTitle")}
        emptyHint={t("empty")}
        icon={<AppWindow size={18} />}
        openPath={(uuid) => spaceAppPath(space.uuid, uuid)}
        options={apps}
        showTitle={false}
      />
    </Page>
  );
}
